import SuperTokens from "supertokens-auth-react";
import EmailVerification from "supertokens-auth-react/recipe/emailverification";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import Session from "supertokens-auth-react/recipe/session";
import ThirdParty, {
  Apple,
  Google,
} from "supertokens-auth-react/recipe/thirdparty";

SuperTokens.init({
  appInfo: {
    // learn more about this on https://supertokens.com/docs/references/frontend-sdks/reference#sdk-configuration
    appName: "Airloom AI",
    apiDomain: import.meta.env.VITE_API_BASE_URL!,
    websiteDomain: import.meta.env.VITE_WEBSITE_DOMAIN!,
    apiBasePath: "/api",
    websiteBasePath: "/account",
  },
  clientType: "web-and-android",
  getRedirectionURL: async (context) => {
    if (context.action === "SUCCESS") {
      // Already-authenticated user hitting the auth page (/account).
      // Without this, returning users get stuck on the auth UI because
      // getRedirectionURL returns null and the prebuilt UI has no session
      // form to show.
      if (!context.newSessionCreated) {
        return "/search";
      }

      // New login/signup flow: SUCCESS with a freshly-created session.
      const currentUrl = new URL(window.location.href);
      const isFromEmailVerification =
        currentUrl.pathname.includes("verify-email") ||
        currentUrl.searchParams.has("token") ||
        document.referrer.includes("verify-email");

      if (isFromEmailVerification) {
        return "/onboarding/awaiting-return";
      }
      if (context.createdNewUser) {
        return "/onboarding/awaiting-return";
      }
      return "/search";
    }
    return null; // Stay on current page - no redirect
  },
  recipeList: [
    EmailPassword.init({
      resetPasswordUsingTokenFeature: {
        disableDefaultUI: false,
      },
    }),
    ThirdParty.init({
      signInAndUpFeature: {
        providers: [Google.init(), Apple.init()],
      },
    }),
    EmailVerification.init({
      mode: "REQUIRED",
    }),
    Session.init(),
  ],
});
